/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudCostMgmtLeakedResource } from './cloudCostMgmtLeakedResource';


/**
 * Paginated response for leaked resources
 */
export interface CloudCostMgmtLeakedResourcesPaginatedResponse { 
    /**
     * Current page size
     */
    current_page_size?: number;
    /**
     * Current page number
     */
    page_number?: number;
    /**
     * Requested page size
     */
    requested_page_size?: number;
    /**
     * Total number of pages
     */
    total_pages?: number;
    /**
     * Total number of records
     */
    total_record_count?: number;
    /**
     * List of leaked resources
     */
    result: Array<CloudCostMgmtLeakedResource>;
}

